import type { Variants, Transition } from 'framer-motion'

// Spring configuration for natural-feeling animations
export const springTransition: Transition = {
  type: 'spring',
  stiffness: 300,
  damping: 30,
}

export const quickSpring: Transition = {
  type: 'spring',
  stiffness: 400,
  damping: 25,
}

// Page transition variants based on navigation direction
export const pageVariants: Variants = {
  enter: (direction: 'forward' | 'backward') => ({
    x: direction === 'forward' ? '100%' : '-100%',
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: 'forward' | 'backward') => ({
    x: direction === 'forward' ? '-100%' : '100%',
    opacity: 0,
  }),
}

export const pageTransition: Transition = {
  x: { type: 'spring', stiffness: 300, damping: 30 },
  opacity: { duration: 0.2 },
}

// Fade in with upward movement
export const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
}

// Fade in with scale
export const fadeInScale: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
  },
}

// Stagger container for child animations
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
}

// Fast stagger for lists
export const fastStagger: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
}

// Scale on tap animation props
export const tapScale = {
  whileTap: { scale: 0.97 },
  transition: quickSpring,
}

// Smaller tap scale for buttons
export const buttonTap = {
  whileTap: { scale: 0.95 },
  transition: { type: 'spring', stiffness: 400, damping: 17 },
}

// Checkmark animation for selections
export const checkmarkVariants: Variants = {
  hidden: {
    scale: 0,
    opacity: 0,
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 500,
      damping: 25,
    },
  },
}

// Pulse animation for upload areas
export const pulseVariants: Variants = {
  pulse: {
    scale: [1, 1.05, 1],
    opacity: [0.7, 1, 0.7],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut',
    },
  },
}

// Celebration animation for completion
export const celebrationVariants: Variants = {
  hidden: {
    scale: 0,
    rotate: -180,
  },
  visible: {
    scale: 1,
    rotate: 0,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 15,
    },
  },
}

// Progress dot animation
export const dotVariants: Variants = {
  inactive: {
    width: 8,
    backgroundColor: 'transparent',
  },
  active: {
    width: 24,
    backgroundColor: '#000000',
  },
  completed: {
    width: 8,
    backgroundColor: '#000000',
  },
}

// Header animation variants
export const headerVariants: Variants = {
  expanded: {
    height: 56,
  },
  collapsed: {
    height: 48,
  },
}

export const headerLogoVariants: Variants = {
  expanded: {
    scale: 1,
    x: 0,
  },
  collapsed: {
    scale: 0.85,
    x: -4,
  },
}
